// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style/StyleButtonFile.scss
// module id = 4265
// module chunks = 0